import { Action } from "../../../../types/state/action";
import {
  IMpnComposition,
  IMpnInformation,
  IMpnRequest,
  IRequestorMarket,
  ITcc,
} from "../../../../types/data.interface";

type ValueOrNull<T> = T | null;
export type Option<T> = { value: T; label: string };

export type CreateMpnState = {
  itemNumber?: ITcc | any;
  requestorInfo: IRequestorMarket;
  composition: IMpnComposition;
  mpnData: IMpnInformation;
  unSavedChanges: boolean;
  isSavingOrSubmiting: boolean;
  mpnRequest: IMpnRequest;
  selectedItemNumberCompositionRows: number[];
  selectedGpCompositionRows: number[];
  selectedMoldIndexes: string[];
  isChangedImportedValues: boolean;
  mpnToClone?: any;
  isLoading?: boolean;
  cloned_sku_id?: any;
  global_product?: any;
  category?: any;
  sub_category?: any;
  product_line?: any;
  fusionSupplier?:any;
};

export enum CreateMpnActionTypes {
  SET_MPN = "setMpn",
  SET_MPN_TO_CLONE = "mpnToClone",
  SET_ITEM_NUMBER = "itemNumber",
  SET_REQUESTOR_INFO = "requestorInfo",
  SET_COMPOSITION = "composition",
  SET_MPN_DATA = "mpnData",
  SET_MPN_REQUEST = "mpnRequest",
  SET_UNSAVED_CHANGES = "unSavedChanges",
  SET_IS_SAVING_OR_SUBMITING = "isSavingOrSubmiting",
  SET_SELECTED_ITEM_NUMBER_COMPOSITION_ROWS = "selectedItemNumberCompositionRows",
  SET_SELECTED_GP_COMPOSITION_ROWS = "selectedGpCompositionRows",
  SET_IS_CHANGED_IMPORTED_VALUES = "isChangedImportedValues",
  SET_SELECTED_MOLD_INDEXES = "selectedMoldIndexes",
  SET_CLONED_SKU_ID = "cloned_sku_id",
  SET_GLOBAL_PRODUCT = "global_product",
  SET_CATEGORY = "category",
  SET_SUB_CATEGORY = "sub_category",
  SET_PRODUCT_LINE = "product_line",
  SET_FUSION_SUPPLIER_ID = "fusionSupplier",
}

export type CreateMpnActionType = Action<
  CreateMpnActionTypes,
  Partial<CreateMpnState>
>;
